import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=39812b8e&scoped=true&"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js&"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&id=39812b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39812b8e",
  null
  
)

export default component.exports